const AcMaintenanceContentArabic = {
    title: "صيانة التكييف",
    breadcrumb: [
        { name: "إتصل بنا", className: "breadcrumb-item", link: "/" },
        { name: "الصفحة", className: "breadcrumb-item", link: "#" },
        { name: "صيانة التكييف", className: "breadcrumb-item active" }
    ],
    buttons: [
        { to: "/contact-us", label: "اتصل بنا", className: "btn btn-primary mt-2 me-2" },
        { to: "/services", label: "خدمات", className: "btn btn-outline-primary mt-2" },
    ],
    introductionTitle: "مقدمة",
    introduction: "تعد صيانة التكييف من العناصر الرئيسية في أي مبنى، لضمان أداء وكفاءة التبريد وجودة الهواء سواء في المباني السكنية او التجارية تعمل أنظمة التكييف على تنظيم درجة حرارة الهواء والرطوبة، مما يوفر بيئة مريحة للمستخدمين. ولكي يبقى النظام يعمل بكفاءة ويحافظ على أدائه المثالي، فإنه يحتاج إلى صيانة منتظمة وعمليات فحص دورية.",
    tableOfContentsTitle: "جدول المحتويات",
    tableOfContents: [
        "أهمية صيانة أنظمة التكييف",
        "أنواع صيانة التكييف",
        "عقود صيانة التكييف",
        "نصائح للحفاظ على أنظمة التكييف",
        "لأي استفسارات اخرى!"
    ],
    importanceOfMaintenance: {
        title:  "أهمية صيانة أنظمة التكييف",
        points: [{ title: "الحفاظ على كفاءة النظام", text: "تنعكس صيانة التكييف على فاعليتها وأدائها الجيد، بمجرد أن تفقد الأنظمة جزءًا من كفاءتها بسبب التآكل أو التراكمات، يتزايد استهلاك الطاقة ويتراجع أداء التبريد أو التدفئة." },
        { title: "توفير الطاقة والتكاليف", text: "صيانة التكييف الدورية تساهم في تحسين كفاءتها، مما يؤدي إلى توفير الطاقة. الحفاظ على تدفق الهواء الجيد، وتنظيف الفلاتر، وتحديث المكونات البالية تساعد في تقليل الضغط على النظام وبالتالي تقليل التكاليف التشغيلية." },
        { title: "ضمان جودة الهواء", text: "صيانة التكييف تعمل على الحفاظ على جودة الهواء الداخلي. الفلاتر والمبخرات النظيفة تسهم في تقليل انتشار الجسيمات الضارة وتحسين جودة الهواء، مما يخدم الصحة العامة للسكان في المبنى." },
        { title: "تجنب الأعطال المفاجئة", text: "صيانة التكييف الدورية تسمح بالكشف عن المشاكل المحتملة قبل أن تتحول إلى أعطال كبيرة. تجنب الأعطال المفاجئة يمنع الإزعاج والتوقف المفاجئ للخدمة، وهو ما يعد من المشاكل المتكررة والغير محتملة وخصوصا بمنطقتنا."},
        { title: "تمديد عمر النظام", text: "صيانة التكييف الدورية تعتبر وسيلة فعّالة لتمديد عمرها. بتلافي المشاكل المحتملة مبكرًا والتعامل معها بفعالية، يمكن تجنب تدهور الأجزاء وتحسين استمرارية الخدمة." },
        ]
    },
    typesOfMaintenance: {
        title:  "أنواع صيانة التكييف",
        preventiveMaintenance: {
            title: "1- صيانة وقائية",
            tasks: [
                { title: "تنظيف الفلاتر", text: "استبدال أو تنظيف الفلاتر بانتظام للحفاظ على تدفق الهواء الجيد وتقليل استهلاك الطاقة."},
                { title: "فحص المكثفات والمبخرات", text: "التحقق من حالتها وتنظيفها لتحسين توزيع الحرارة."},
                { title: "فحص الضواغط", text: "يجب فحص الضواغط بشكل دوري، وذلك للتأكد من سلامتها وعدم وجود أعطال بها."},
                { title: "التحقق من مستوى الفريون", text: "التأكد من أن مستوى الغاز في الوحدة الخارجية ملائم للحفاظ على كفاءة التبريد."},
                { title: "فحص الأسلاك والموصلات", text: "التحقق من سلامة الأسلاك والتأكد من عدم وجود تمزق أو تلف."},
                { title: "تنظيف الدكت 'Duct'", text: " يجب تنظيف الدكت (مجاري الهواء) كل عام، وذلك لإزالة الأتربة والغبار العالق بها، والتي قد تتسبب في إعاقة تدفق الهواء."},
            ]
        },
        emergencyMaintenance: {
            title: "2- صيانة طارئة",
            tasks: [
                { title: "إصلاح التسريبات", text: "التحقق من شبكة تمديدات الدكت “Duct” للتأكد من التسريبات وتفادي فقدان الهواء. وفحص مواسير النحاس لتفادي تسريب الفريون."},
                { title: "تصحيح مشاكل الضغط", text: " ضبط الضغط في النظام للحفاظ على توزيع فعال للهواء."},
                { title: "إصلاح المكونات التالفة", text: "استبدال أو إصلاح أي جزء تالف يؤثر على أداء النظام."},
            ]
        }
    },
    maintenanceContracts: {
        title: "عقود صيانة التكييف",
        text: "نقدم في المتحدة للتكييف عقود صيانة التكييف تشمل خدمات دورية وعاجلة. تتضمن هذه العقود:",
        details: [
            { title: "زيارات دورية", text: "تنفيذ صيانة دورية وفحص لضمان سلامة وكفاءة النظام."},
            { title: "التفتيش الفوري", text: "توفير خدمات فورية في حالة حدوث عطل أو مشكلة غير متوقعة."},
            { title: "توفير قطع الغيار", text: "تأمين قطع الغيار اللازمة للإصلاح والاستبدال."},
            { title: "تقارير الصيانة", text: "اعداد تقارير دورية توضح حالة النظام والإجراءات التي تم اتخاذها."},
            { title: "التخفيضات والامتيازات", text: " توفير خصومات على قطع الغيار وخدمات الإصلاح كجزء من العقد."},
        ]
    },
    tipsForMaintenance: {
        title: "نصائح للحفاظ على أنظمة التكييف",
        text: "بالإضافة إلى إجراء صيانة التكييف الدورية، هناك بعض النصائح التي يمكن اتباعها للحفاظ على أنظمة التكييف، ومنها:",
        tips: [
            "تشغيل التكييف على درجة حرارة مناسبة، بحيث لا تقل درجة الحرارة عن 22 درجة مئوية.",
            "عدم تشغيل التكييف في حالة عدم وجود أحد في الغرفة.",
            "غلق النوافذ والأبواب أثناء تشغيل التكييف لضمان عدم تسرب الهواء البارد.",
            "تنظيف الوحدة الخارجية بشكل دوري.",
            "تنظيف فلاتر الوحدة الداخلية بشكل دوري."
        ]
    },
    otherInquiries: {
        title: "لأي استفسارات اخرى!",
        text1: "نقدم خدمات صيانة التكييف من قبل مهندسين وفنيين مؤهلين وذوي خبرة للتأكد من أن النظام يعمل بشكل صحيح وفقًا للمعايير والمتطلبات المحددة.",
        text2: "نسعى دائماً الى تقديم حلول وخدمات فريدة مصممه خصيصاَ وفق احتياجات عملائنا، لتبدأ رحلتنا من حيث انتهى الاخرون لنقدم لعملائنا “حلول مبتكرة …. لحياة أسهل.",
        text3: "لا تترد لطلب خدمة صيانة التكييف، أو أي استفسار عن أنظمة التكييف المختلفة وايهما أنسب لمشروعك، مهندسينا في انتظار طلبك، ومساعدتك. فقط اضغط على زر “اتصل بنا”، او تحدث مع مهندسنا عبر واتساب.",
    }
}

export { AcMaintenanceContentArabic }